// zone.js MUST be imported before bootstrapApplication.
// Without it, Angular has no way to detect when async operations (HTTP, setTimeout,
// Promises, RxJS subscriptions) complete, so templates never re-render automatically.
import 'zone.js';

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// ── Deployment-safe auto-reload ─────────────────────────────────────────────
// After a deployment, the browser may have old index.html cached which references
// stale JS chunk hashes. When dynamic import() fails to load those chunks (404),
// this listener auto-reloads the page so the user gets the new index.html with
// correct hashes — no manual hard refresh needed.
// The cooldown prevents infinite reload loops.
const RELOAD_COOLDOWN_MS = 60_000;
let lastChunkReload = 0;

window.addEventListener(
  'error',
  (event) => {
    // Only handle script / module load failures (e.g. chunk-not-found after deploy)
    const target = event.target as HTMLElement | null;
    if (
      target?.tagName === 'SCRIPT' ||
      target?.tagName === 'LINK' ||
      (event instanceof ErrorEvent && /Loading chunk.*failed|Failed to load module script/i.test(event.message))
    ) {
      const now = Date.now();
      if (now - lastChunkReload > RELOAD_COOLDOWN_MS) {
        lastChunkReload = now;
        console.warn('[main] Detected chunk/script load failure — auto-reloading.');
        window.location.reload();
      }
    }
  },
  true, // capture phase to catch bubbling script errors
);

// Zone.js surfaces NavigationCancelingError (redirect type) as an unhandled promise
// rejection before Angular's router catch-handler runs. This fires before AppErrorHandler
// gets a chance to suppress it, so we intercept it here with event.preventDefault().
window.addEventListener(
  'unhandledrejection',
  (event) => {
    const error = event.reason;
    if (
      error instanceof Error &&
      (error.message.includes('Redirecting to') ||
        (error as any).cancellationCode === 0 ||
        (error as any).type === 0)
    ) {
      event.preventDefault();
    }
  },
  true,
);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
